import { useGetById } from './useRecentActivity'

export const recentActivity = {
  getById: useGetById,
}
